'use strict';

import df from 'deep-freeze';
import { merge } from 'lodash';

import sharedConfig from './shared-config';


export default df(merge({
    debug: {
        level: 'warn',
    },
}, sharedConfig));
